import { SourceEnum } from 'js/src/client';

export const ON_RENDER_COMPLETE_EVENT = 'onRenderComplete';

// some useful color prop name
export const TEXT_HIGHLIGHT_PROP = 'highlightStyle.fill';

export const TEXT_EDITING_ERR_EVENT = 'nte-editing-exception';

export const LUMINARY_VIDEO_STORE_NAME = 'videoStore';

export const SOURCE_DISPLAY_NAME = {
    [SourceEnum.SOURCE_USER]: 'Uploads',
    [SourceEnum.SOURCE_USER_WATERMARK]: 'Uploads',
    [SourceEnum.SOURCE_USER_OUTRO]: 'Uploads',
    [SourceEnum.SOURCE_NOUNPROJECT]: 'The Noun Project',
    [SourceEnum.SOURCE_PEXELS]: 'Pexels',
    [SourceEnum.SOURCE_PIXABAY]: 'Pixabay',
    [SourceEnum.SOURCE_UNSPLASH]: 'Unsplash',
    [SourceEnum.SOURCE_VIDEOBLOCKS]: 'Videoblocks',
    [SourceEnum.SOURCE_VIDEVO]: 'Videvo',
    [SourceEnum.SOURCE_WIKIMEDIA]: 'Wikimedia Commons',
    [SourceEnum.SOURCE_GRAPHICSTOCK]: 'Graphicstock',
    [SourceEnum.SOURCE_COVERR]: 'Coverr',
    [SourceEnum.SOURCE_WEDISTILL]: 'WeDistill',
    [SourceEnum.SOURCE_ARTICLE]: 'Article',
    [SourceEnum.SOURCE_LUMEN5_COLOURS]: 'Lumen5',
    [SourceEnum.SOURCE_TENOR]: 'Tenor',
    [SourceEnum.SOURCE_GETTY]: 'Getty Images',
    [SourceEnum.SOURCE_GETTY_UNLIMITED]: 'Getty Images',
    [SourceEnum.SOURCE_SHUTTERSTOCK_ESSENTIALS]: 'Shutterstock',
    [SourceEnum.SOURCE_SHUTTERSTOCK_PREMIUM]: 'Shutterstock',
    [SourceEnum.SOURCE_SHUTTERSTOCK_EDITORIAL]: 'Shutterstock',
    [SourceEnum.SOURCE_SHUTTERSTOCK_UNLIMITED]: 'Shutterstock',
    [SourceEnum.SOURCE_SHUTTERSTOCK_CHOICES]: 'Shutterstock',
    [SourceEnum.SOURCE_LUMEN5_ASSETS]: 'Lumen5',
    [SourceEnum.SOURCE_LUMEN5_ICONS_PREMIUM]: 'Lumen5',
};

export const SOURCE_INFO_URL = {
    [SourceEnum.SOURCE_USER]:
        'https://help.lumen5.com/en/article/uploading-or-deleting-your-own-photos-and-videos-b4h6g1/',
    [SourceEnum.SOURCE_USER_WATERMARK]:
        'https://help.lumen5.com/en/article/uploading-or-deleting-your-own-photos-and-videos-b4h6g1/',
    [SourceEnum.SOURCE_USER_OUTRO]:
        'https://help.lumen5.com/en/article/uploading-or-deleting-your-own-photos-and-videos-b4h6g1/',
    [SourceEnum.SOURCE_NOUNPROJECT]: 'https://thenounproject.com/',
    [SourceEnum.SOURCE_PEXELS]: 'https://www.pexels.com/',
    [SourceEnum.SOURCE_PIXABAY]: 'https://pixabay.com/en/',
    [SourceEnum.SOURCE_UNSPLASH]: 'https://unsplash.com/',
    [SourceEnum.SOURCE_VIDEOBLOCKS]: 'https://www.videoblocks.com/',
    [SourceEnum.SOURCE_VIDEVO]: 'https://www.videvo.net/',
    [SourceEnum.SOURCE_WIKIMEDIA]: 'https://commons.wikimedia.org/wiki/Main_Page',
    [SourceEnum.SOURCE_GRAPHICSTOCK]: 'https://www.storyblocks.com/stock-image',
    [SourceEnum.SOURCE_COVERR]: 'https://coverr.co/',
    [SourceEnum.SOURCE_WEDISTILL]: 'http://www.wedistill.io/',
    [SourceEnum.SOURCE_ARTICLE]:
        'https://help.lumen5.com/en/article/can-i-use-images-from-my-article-hw7qyp/',
    [SourceEnum.SOURCE_TENOR]: 'https://tenor.com/',
    [SourceEnum.SOURCE_GETTY]: 'https://www.gettyimages.com/',
    [SourceEnum.SOURCE_GETTY_UNLIMITED]: 'https://www.gettyimages.com/',
    [SourceEnum.SOURCE_SHUTTERSTOCK_ESSENTIALS]: 'https://www.shutterstock.com/',
    [SourceEnum.SOURCE_SHUTTERSTOCK_PREMIUM]: 'https://www.shutterstock.com/',
    [SourceEnum.SOURCE_SHUTTERSTOCK_EDITORIAL]: 'https://www.shutterstock.com/',
    [SourceEnum.SOURCE_SHUTTERSTOCK_UNLIMITED]: 'https://www.shutterstock.com/',
    [SourceEnum.SOURCE_SHUTTERSTOCK_CHOICES]: 'https://www.shutterstock.com/',
};
